import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    var selector = "[data-parallax]";
    var registered = false;
    var tweens = [];

    function init() {
        if (!$(selector).length) return;

        if (window.innerWidth < 768) {
            tweens.forEach(function (t) {
                t.revert();
            });
            tweens = [];
            return;
        }

        if (tweens.length) return;

        jdmn.log("function_parallax.js initialized", "green");

        if (!registered) {
            gsap.registerPlugin(ScrollTrigger);
            registered = true;
        }

        $(selector).each(function () {
            var $instance = $(this);
            var $trigger = $instance.parents(".layout");
            var factor = parseFloat($instance.attr("data-parallax")) || 1;

            tweens.push(
                gsap.from($instance[0], {
                    y: window.innerHeight / factor,
                    scrollTrigger: {
                        trigger: $trigger[0],
                        start: "top bottom",
                        end: "bottom top",
                        scrub: 0.5,
                    },
                }),
            );
        });
    }

    // $(document).ready(init);
    $(window).on("load resizeEnd", init);
})();
